import React, { useState, useEffect } from 'react';
import { VitalProvider } from './contexts/VitalProvider';

import AuthLanding  from './components/auth/AuthLanding';
import ScanPage     from './components/ScanPage';
import ResultsPage  from './components/ResultsPage';
import HomePage     from './components/home/HomePage';
import SettingsPage from './components/settings/SettingsPage';
import ProfilePage  from './components/profile/ProfilePage';
import NavBar       from './components/NavBar';
import './App.scss';

export default function App () {
  const [isLoggedIn, setLoggedIn] = useState(
    Boolean(sessionStorage.getItem('token') && sessionStorage.getItem('licence'))
  );

  const [activeTab, setActiveTab] = useState('home');

  useEffect(() => {
    const cached = sessionStorage.getItem('lastScan');
    if (cached) {
      const data = JSON.parse(cached);
      window.dispatchEvent(new CustomEvent('vitals-update', { detail: data }));
      setActiveTab('results');
      sessionStorage.removeItem('lastScan');
    }
  }, []);

  let Content;
  if (!isLoggedIn) {
    Content = <AuthLanding onAuthSuccess={() => setLoggedIn(true)} />;
  } else {
    switch (activeTab) {
      case 'home'    : Content = <HomePage   />; break;
      case 'scan'    : Content = <ScanPage   />; break;       
      case 'results' : Content = <ResultsPage/>; break;
      case 'settings': Content = <SettingsPage/>; break;
      case 'profile' : Content = <ProfilePage />; break;
      default        : Content = <HomePage   />;
    }
  }

  return (
    <VitalProvider>
      <div className="app-container">
        <div className="mobile-wrapper">
          <div className="content-area">{Content}</div>

          {isLoggedIn && activeTab !== 'scan' && (
            <NavBar active={activeTab} onChange={setActiveTab} />
          )}
        </div>
      </div>
    </VitalProvider>
  );
}
